export const PortalObjectTypeIds = {
  qa: '2-5868076',
  prod: '2-5945472'
};
export const MrrUsdPropertyNames = {
  qa: 'mrr_usd_53_test',
  prod: 'total_mrr_usd_53'
};